// Respaldo bilingue de los avisos del contenido social: feed, publicaciones,
// foros, eventos, chat, promociones y traduccion de textos.
//
// POR QUE EXISTE: son el `||` que cubre una clave del esquema remoto
// (/api/lang/sch) que hoy no llega. Estaban escritos solo en espanol, asi que
// quien tenia la interfaz en ingles los leia en otro idioma que el resto de la
// pantalla.
//
// COMO SE RETIRA: el esquema remoto SIEMPRE gana; el dia que backend publique
// ER0116, ER0048, ER0049, ER0058, ER0090, ER0091, ER0093, ER0096 y las demas,
// estos respaldos dejan de usarse solos.
//
// `translateFailed` se comparte entre cinco pantallas (foro, publicaciones,
// galeria, perfil de otra persona y comentarios): el mismo aviso se comparte, no
// se copia.

import { normalizeInterfaceLanguage } from "../interfaceLanguage";

const socialMessages = {
  es: {
    translateFailed: "Error al traducir texto",
    voteFailed: "Error al procesar el voto. Por favor, inténtalo de nuevo más tarde.",
    getCommentsFailed: "No se pudieron obtener los comentarios",
    deletePostFailed:
      "Error al intentar eliminar la publicación. Por favor, inténtalo de nuevo más tarde.",
    hidePostFailed:
      "Error al intentar ocultar la publicación. Por favor, inténtalo de nuevo más tarde.",
    reportPostFailed:
      "Error al intentar reportar la publicación. Por favor, inténtalo de nuevo más tarde.",
    publicationUpdated: "Publicación actualizada correctamente",
    forumShared: "Foro compartido correctamente",
    eventShared: "Evento compartido correctamente",
    ratingSubmitted: "Calificación enviada correctamente",
    complaintSubmitted: "Queja enviada correctamente.",
    reportSent: "Reporte enviado.",
    reportFailed: "No se pudo enviar el reporte.",
    attachmentTooLarge: (nombre, mb) => `"${nombre}" supera ${mb} MB.`,
    missingChatId: "Falta el identificador del chat.",
    chatArchived: "Chat archivado.",
    archiveChatFailed: "No se pudo archivar el chat.",
    chatDeleted: "Chat eliminado.",
    deleteChatFailed: "No se pudo eliminar el chat.",
    refreshFeedFailed: "Error al actualizar el feed",
    loadUserInfoFailed:
      "Error al cargar la información del usuario. Por favor, inténtalo de nuevo más tarde.",
    loadForumsFailed:
      "Error al cargar los foros. Por favor, inténtalo de nuevo más tarde.",
    reportForumFailed: "Error al reportar foro",
    loadPublicationFailed:
      "Error al cargar publicación o imagen, por favor intente más tarde.",
    loadCommentsFailed: "Error al cargar comentarios, por favor intente más tarde.",
    shareFailed:
      "Error al intentar compartir la publicación. Por favor, inténtalo de nuevo más tarde.",
    reactionFailed: "No se pudo guardar la reaccion",
    loadEventsFailed: "Error al cargar eventos",
    cancelEventFailed: "Error al cancelar el evento, por favor intente más tarde.",
    deleteEventFailed: "Error al eliminar el evento, por favor intente más tarde.",
    selectUser: "Selecciona un usuario.",
    promotionCreated: "Promoción creada con éxito",
  },
  en: {
    translateFailed: "Could not translate the text",
    voteFailed: "Error processing vote. Please try again later.",
    getCommentsFailed: "Failed to get comments",
    deletePostFailed: "Error trying to delete the post. Please try again later.",
    hidePostFailed: "Error trying to hide the post. Please try again later.",
    reportPostFailed: "Error trying to report the post. Please try again later.",
    publicationUpdated: "Publication updated correctly",
    forumShared: "Forum shared successfully",
    eventShared: "Event shared successfully",
    ratingSubmitted: "Rating successfully submitted",
    complaintSubmitted: "Complaint submitted correctly.",
    reportSent: "Report sent.",
    reportFailed: "The report could not be sent.",
    attachmentTooLarge: (name, mb) => `"${name}" surpasses ${mb} MB.`,
    missingChatId: "The chat id is missing.",
    chatArchived: "Chat archived.",
    archiveChatFailed: "Could not archive the chat.",
    chatDeleted: "Chat deleted.",
    deleteChatFailed: "Could not delete the chat.",
    refreshFeedFailed: "Could not refresh the feed",
    loadUserInfoFailed:
      "Could not load the user information. Please try again later.",
    loadForumsFailed: "Could not load the forums. Please try again later.",
    reportForumFailed: "Could not report the forum post",
    loadPublicationFailed:
      "Could not load the post or its image, please try again later.",
    loadCommentsFailed: "Could not load the comments, please try again later.",
    shareFailed: "Could not share the post. Please try again later.",
    reactionFailed: "Could not save the reaction",
    loadEventsFailed: "Could not load the events",
    cancelEventFailed: "Could not cancel the event, please try again later.",
    deleteEventFailed: "Could not delete the event, please try again later.",
    selectUser: "Select a user.",
    promotionCreated: "Promotion created successfully",
  },
};

export const getSocialMessages = (language) =>
  socialMessages[normalizeInterfaceLanguage(language)];
